import { msg } from "@lingui/core/macro"

export const INBOX_VERSION_V2 = "v2"
export const DM_WINDOW_LOCATION = "DMWindow"

export enum NEWRELIC_SOURCE {
    Mobile = "mobile",
    Desktop = "desktop",
    DesktopPopout = "desktop_popout",
}

export const CAUTION_PASSWORD = msg`Caution: The Chaturbate Team will NEVER contact you via chat or ask for your password.`
